import { sanitizeHtml } from "@/utils/sanitizeHtml";

/**
 * 商品详情
 * @param title
 * @returns content
 */
const ProductContent = ({
  title,
  content,
}: {
  title: string;
  content: string;
}) => {
  return (
    <div className="px-mobile lg:px-0 mb-25 lg:mb-20 flex w-full flex-col">
      <div className="mb-4 lg:mb-12 font-semibold w-full text-center text-base lg:text-3xl lg:font-medium">
        {title}
      </div>
      <div
        className="goods-detail-content flex w-full flex-col"
        dangerouslySetInnerHTML={{ __html: sanitizeHtml(content) }}
      ></div>
      <style jsx global>
        {`
          .goods-detail-content img,
          .goods-detail-content video {
            max-width: 100%;
          }
        `}
      </style>
    </div>
  );
};

export default ProductContent;
